// Словарь интернет-эквайринга Т-Банка: оплата счёта картой из кабинета клиента. Подключается в `ru.ts`.

/** «Настройки → Эквайринг» и тексты заказа (ключи `finance.acquiring.*`). */
export const ruFinanceAcquiring = {
  title: 'Эквайринг',
  lead: 'Оплата счетов картой и по СБП из кабинета клиента через интернет-эквайринг Т-Банка',
  hint: {
    title: 'Как это работает',
    text: 'У неоплаченного счёта в кабинете клиента появляется «Оплатить картой». Клиент платит на странице Т-Банка, банк присылает уведомление — оплата записывается на выбранный счёт студии и закрывает счёт клиента сама. Пароль терминала хранится зашифрованным и назад не показывается',
    example:
      'Клиент оплатил СЧ-2026-0012 картой — через секунды счёт «Оплачен», этапы, ждавшие оплаты, открылись',
  },
  terminal: {
    title: 'Терминал',
    lead: 'Terminal key и пароль — в личном кабинете Т-Бизнеса: Интернет-эквайринг → Магазины → Терминалы',
    enabled: 'Принимать оплату картой',
    enabledHint: 'Выключите — кнопка «Оплатить картой» пропадёт из кабинета клиента',
    terminalKey: 'Terminal key',
    terminalKeyHint: 'Тестовый терминал заканчивается на DEMO',
    password: 'Пароль терминала',
    passwordHint: 'Оставьте пустым, чтобы не менять сохранённый',
    passwordSaved: 'Сохранён — введите новый, чтобы заменить',
    testMode: 'Тестовый терминал',
    testModeHint: 'Деньги не списываются; клиенту в кабинете видна пометка «тестовая оплата»',
    autopay: 'Автоплатёж подписок',
    autopayHint:
      'При оплате счёта подписки поддержки клиент оставляет галочку — карта сохраняется у банка, следующие счета подписки списываются сами. Рекуррентные платежи подключаются к терминалу в Т-Бизнесе',
    dolyame: 'Оплата долями',
    dolyameHint:
      'Кнопка «Оплатить долями» в кабинете: 4 платежа раз в две недели, студия получает всю сумму сразу. «Долями» подключается к терминалу в Т-Бизнесе',
    receipt: 'Чек по 54-ФЗ',
    receiptHint:
      'Включите, если к терминалу подключена онлайн-касса: банк без чека заказ не примет. Чек уходит на почту клиента из кабинета, у «Проверить подключение» — на почту студии',
    taxation: 'Система налогообложения',
    vat: 'НДС в чеке',
    taxations: {
      osn: 'ОСН',
      usn_income: 'УСН «Доходы»',
      usn_income_outcome: 'УСН «Доходы минус расходы»',
      esn: 'ЕСХН',
      patent: 'Патент',
    },
    vats: {
      none: 'Без НДС',
      vat0: 'НДС 0 %',
      vat5: 'НДС 5 %',
      vat7: 'НДС 7 %',
      vat10: 'НДС 10 %',
      vat20: 'НДС 20 % (до 2026 года)',
      vat22: 'НДС 22 %',
    },
    cardOnlyHint: 'Карта, «Долями» и автоплатёж — только физлицам и ИП. Организации платят по счёту',
    account: 'Счёт для поступлений',
    accountHint: 'Сюда записываются оплаты картой — счёт студии, куда банк перечисляет возмещение',
    accountEmpty: 'Сначала заведите счёт студии в Финансах → Счета',
    save: 'Сохранить',
    saved: 'Настройки эквайринга сохранены',
    check: 'Проверить подключение',
    checked: 'Банк принял ключ и пароль терминала',
    checkedAt: 'Проверено {date}',
    notChecked: 'Подключение ещё не проверено',
    testBadge: 'Тестовый',
    activeBadge: 'Принимает оплату',
    offBadge: 'Выключен',
  },
  notification: {
    title: 'Уведомления банка',
    lead: 'Впишите этот адрес в настройках терминала в Т-Бизнесе («Уведомления» → «По HTTP»), чтобы оплаты отмечались за секунды',
    missing:
      'У платформы нет HTTPS-адреса — банк не сможет прислать уведомление. Оплата отметится, когда клиент вернётся в кабинет со страницы банка',
    copy: 'Скопировать',
    copied: 'Адрес скопирован',
  },
  orderDescription: 'Оплата по счёту № {number}',
  checkDescription: 'Проверка подключения',
  autopayDescription: 'Автоплатёж по счёту № {number}',
  purpose: 'Оплата картой по счёту № {number}, платёж Т-Банка {payment}',
  refundPurpose: 'Возврат оплаты картой по счёту № {number}, платёж Т-Банка {payment}',
  source: 'Картой (Т-Банк)',
  tab: 'Оплаты картой',
  orders: {
    title: 'Заказы у банка',
    lead: 'Каждая попытка оплаты картой из кабинета и каждое списание автоплатежа — со статусом банка и причиной отказа',
    empty: 'Оплат картой пока не было',
    emptyFiltered: 'Таких заказов нет',
    outcomes: { all: 'Все', paid: 'Оплачены', open: 'В процессе', failed: 'Не прошли', other: 'Прочие' },
    client: 'Клиент платил сам',
    autopay: 'Автоплатёж',
    recurrent: 'с сохранением карты',
    dolyame: 'Долями',
    card: 'Карта',
    invoice: 'Счёт {number}',
    bankPayment: 'Платёж банка {id}',
    order: 'Заказ {id}',
  },
  autopays: {
    title: 'Автоплатежи подписок',
    lead: 'Карты клиентов, сохранённые для подписок поддержки. Списание — раз в час по новым счетам подписки, по счёту не чаще раза в сутки и не больше трёх отказов',
    empty: 'Автоплатежей пока нет — они появляются, когда клиент оплачивает счёт подписки картой с галочкой',
    active: 'Действует',
    off: 'Отключён',
    card: 'Карта {pan}',
    cardUnknown: 'Карта сохранена',
    since: 'с {date}',
    charges: 'Списаний {paid} из {total}, отказов {failed}',
    noCharges: 'Списаний ещё не было',
    last: 'Последнее {date}: {status}',
    disabledBy: { client: 'отключил клиент', staff: 'отключил сотрудник', replaced: 'заменён новой картой' },
    disable: 'Отключить',
    disabled: 'Автоплатёж отключён',
  },
  statuses: {
    NEW: 'Создан',
    FORM_SHOWED: 'Открыта форма оплаты',
    AUTHORIZING: 'Проверка карты',
    '3DS_CHECKING': 'Проверка 3-D Secure',
    '3DS_CHECKED': 'Проверка 3-D Secure пройдена',
    AUTHORIZED: 'Деньги заблокированы',
    CONFIRMING: 'Подтверждается',
    CONFIRMED: 'Оплачен',
    REVERSING: 'Отменяется',
    PARTIAL_REVERSED: 'Частично отменён',
    REVERSED: 'Отменён',
    REFUNDING: 'Возвращается',
    PARTIAL_REFUNDED: 'Частичный возврат',
    REFUNDED: 'Возвращён',
    CANCELED: 'Отменён',
    DEADLINE_EXPIRED: 'Истёк срок оплаты',
    REJECTED: 'Отклонён',
    AUTH_FAIL: 'Не прошла 3-D Secure',
  },
} as const;

/** Ошибки эквайринга (в `errors.finance`). */
export const ruFinanceAcquiringErrors = {
  acquiring_receipt_email: 'Для чека нужна почта: укажите её в профиле кабинета или в реквизитах студии',
  acquiring_invoice_only: 'Организации оплачивают по счёту — реквизиты рядом',
  acquiring_incomplete: 'Заполните terminal key, пароль терминала и счёт для поступлений',
  acquiring_disabled: 'Оплата картой сейчас недоступна — оплатите по реквизитам',
  acquiring_nothing_to_pay: 'Счёт уже оплачен',
  acquiring_rejected: 'Т-Банк отклонил запрос: {message}',
  acquiring_unavailable: 'Т-Банк не отвечает — попробуйте ещё раз через минуту',
  acquiring_bad_response: 'Т-Банк ответил не так, как ожидалось — попробуйте ещё раз',
} as const;

/** «История» и журнал (в `audit`). */
export const ruFinanceAcquiringAudit = {
  actions: {
    finance_acquiring: {
      changed: 'Изменены настройки эквайринга',
      autopay_disabled: 'Отключён автоплатёж подписки',
    },
  },
  entities: {
    finance_acquiring: 'Эквайринг',
  },
  fields: {
    acquiringEnabled: 'Оплата картой включена',
    terminalKey: 'Terminal key',
    testMode: 'Тестовый терминал',
    autopayEnabled: 'Автоплатёж подписок',
    dolyameEnabled: 'Оплата долями',
    receiptEnabled: 'Чек по 54-ФЗ',
    taxation: 'Система налогообложения',
    vat: 'НДС в чеке',
    autopayPan: 'Карта автоплатежа',
    acquiringPassword: 'Пароль терминала заменён',
  },
} as const;
